import React from 'react';
import strings from 'strings';

import { BannerMobile } from '../Banner';
import * as styles from './ActiveTransporterBanner.scss';

const ActiveTransporterBannerMobile = (props) => {
  const {
    activeTransporterUrl,
    closeBanner,
    imageUrl,
  } = props;

  return (
    <BannerMobile
      url={activeTransporterUrl}
      closeBanner={closeBanner}
      primaryText={strings.searchActiveTransporters}
      secondaryText={strings.useWhenWaitingLong}
      buttonText={strings.try}
      imageUrl={imageUrl}
      imageAlt="truck-image"
      className={styles.activeTransporterBanner}
    />
  );
};

export default ActiveTransporterBannerMobile;
